import React from "react";
import '../../styles/otpfield.css';

const OTPField = (props) => {
    return (
        <div className="otp-field-container">
            <input placeholder="- - - - - -" maxLength={6} value={props.value} onChange={(e) => { props.onChange(e.target.value) }} type="text" inputMode="numeric"/>
        </div>
    )
}
export default OTPField;